import * as yup from 'yup'

export const addPrebuiltOption = yup.object().shape({
    name: yup.string().required('required'),
    options: yup.array().of(yup.object({ label: yup.string(), value: yup.string() })),
})
